import { __spreadArray } from "tslib";
import { midPoint } from '../util/mid-point';
export var lineToCubic = function (x1, y1, x2, y2) {
    var t = 0.5;
    var mid = midPoint([x1, y1], [x2, y2], t);
    return __spreadArray(__spreadArray([], mid, true), [x2, y2, x2, y2], false);
};
//# sourceMappingURL=line-2-cubic.js.map